<template>
  <div class="crud_form_wrapper">
    <div class="form_title_wrapper">
      <h4>{{ $t("TITLES.show_offer") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #008274">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>

    <div class="single_step_form_content_wrapper show">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <p class="text-center">{{ $t("PLACEHOLDERS.images") }}</p>
          <UploadMedia
            :multiple="true"
            :for_id="'ad_images'"
            :content="$t('PLACEHOLDERS.images')"
            ref="ad_images"
            accept="image/*"
            disabled
          />
          <base-image-upload-input
            col="12"
            identifier="video"
            :placeholder="$t('PLACEHOLDERS.video')"
            :acceptVideo="true"
            v-if="data.video.path"
            :preSelectedImage="data.video.path"
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.license_number')"
            v-model.trim="data.license_number"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.ad_number')"
            v-model.trim="data.adNum"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.ad_name')"
            v-model.trim="data.name"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.created_at')"
            v-model.trim="data.created_at"
            disabled
          />

          <base-select-input
            col="6"
            :placeholder="$t('PLACEHOLDERS.ad_type')"
            v-model="data.ad_type"
            :optionsList="adTypes"
            disabled
          />
          <base-select-input
            col="6"
            disabled
            :placeholder="$t('PLACEHOLDERS.estate_purpose')"
            v-model="data.estate_purpose"
            :optionsList="estatePurposeTypes"
          />
          <base-select-input
            col="6"
            disabled
            :placeholder="$t('PLACEHOLDERS.estate_type')"
            v-model="data.estate_type"
            :optionsList="estateTypes"
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.appearance_type')"
            disabled
            :value="
              data.apperance_type
                ? $t('PLACEHOLDERS.distinct')
                : $t('PLACEHOLDERS.indiscriminate')
            "
          />
          <base-select-input
            col="6"
            disabled
            v-if="data.rent_type?.value !== 'daily'"
            :placeholder="$t('PLACEHOLDERS.ban_type')"
            v-model="data.ban_type"
            :optionsList="banTypes"
          />
          <base-input
            col="6"
            type="number"
            :placeholder="$t('PLACEHOLDERS.price')"
            v-model="data.price"
          />

          <v-date-picker
            v-model="blocked_days"
            disabled
            :allowed-dates="() => true"
            :active-picker.sync="activePicker"
            v-if="data.rent_type?.value == 'daily'"
            :value="null"
            multiple
          >
            <template v-slot:day="{ date }">
              <v-btn
                :color="selectedDates.includes(date) ? 'primary' : ''"
                text
                small
                @click="toggleDate(date)"
              >
                {{ new Date(date).getDate() }}
              </v-btn>
            </template>
          </v-date-picker>

          <base-select-input
            col="6"
            disabled
            v-model="data.state"
            :optionsList="states"
            :placeholder="$t('PLACEHOLDERS.state')"
          />
          <base-select-input
            col="6"
            v-model="data.city"
            :optionsList="cities"
            disabled
            :placeholder="$t('PLACEHOLDERS.city')"
          />
          <base-select-input
            col="6"
            v-model="data.district"
            disabled
            :optionsList="districts"
            :placeholder="$t('PLACEHOLDERS.district')"
          />

          <p class="mb-5 px-3" style="color: #072e68; font-size: 16px">
            {{ $t("PLACEHOLDERS.location_on_map")
            }}<span class="text-danger"> * </span>
          </p>
          <MapComponent
            :lat="parseFloat(data.lat)"
            :lng="parseFloat(data.lng)"
            disabled
          />

          <base-select-input
            col="6"
            v-if="data.ad_type?.value === 'rent'"
            :placeholder="$t('PLACEHOLDERS.rent_type')"
            v-model="data.rent_type"
            disabled
            :optionsList="rentTypes"
          />
          <base-input
            col="6"
            disabled
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.description')"
            v-model.trim="data.description"
          />
          <base-select-input
            col="6"
            disabled
            v-if="data.rent_type?.value !== 'daily'"
            :placeholder="$t('PLACEHOLDERS.estate_front')"
            :optionsList="facadeTypes"
            v-model="data.estate_front"
          />

          <base-input
            col="6"
            disabled
            type="number"
            :placeholder="$t('PLACEHOLDERS.area')"
            v-model="data.area"
          />

          <base-input
            col="6"
            disabled
            v-if="data.rent_type?.value !== 'daily'"
            type="number"
            :placeholder="$t('PLACEHOLDERS.street_width')"
            v-model="data.street_width"
          />

          <base-select-input
            col="6"
            disabled
            v-model="data.additional_fields"
            :optionsList="additional_fields"
            :placeholder="$t('PLACEHOLDERS.additional_fields')"
            multiple
          />

          <template>
            <div class="custom-form-wrapper">
              <div
                v-for="field in data.additional_fields"
                :key="field.id"
                class="custom-form-field"
              >
                <div v-if="field.type === 'text'">
                  <base-input
                    v-model="field.values"
                    type="text"
                    disabled
                    :placeholder="field.name"
                    :icon="field.icon"
                    :required="Boolean(field.is_required)"
                  />
                </div>

                <div v-else-if="field.type === 'number'">
                  <base-input
                    v-model.number="field.values"
                    type="number"
                    disabled
                    :placeholder="field.name"
                    :required="Boolean(field.is_required)"
                    :icon="field.icon"
                  />
                </div>

                <div v-else-if="field.type === 'textarea'">
                  <base-input
                    v-model="field.values"
                    type="textarea"
                    disabled
                    :placeholder="field.name"
                    :icon="field.icon"
                    :required="Boolean(field.is_required)"
                  />
                </div>

                <div v-else-if="field.type === 'checkbox'" class="my-3">
                  <label class="field-label d-block mb-2">
                    <img v-if="field.icon" :src="field.icon" class="img" />
                    {{ field.name }}
                    <span class="text-danger" v-if="Boolean(field.is_required)"
                      >*</span
                    >
                  </label>
                  <label
                    v-for="option in field.options"
                    :key="option.id"
                    class="custom-checkbox-wrapper"
                  >
                    <input
                      type="checkbox"
                      class="custom-checkbox-input"
                      :value="option"
                      v-model="field.values"
                      disabled
                    />
                    <span
                      class="custom-checkbox-box"
                      :class="{
                        bg: field.values.some((val) => val.id === option.id),
                      }"
                    ></span>
                    <span class="custom-checkbox-label">
                      {{ option.trans?.option_name?.ar || option.name }}
                    </span>
                  </label>
                </div>

                <div v-else-if="field.type === 'radio'">
                  <label class="field-label d-block mb-2">
                    <img v-if="field.icon" :src="field.icon" class="img" />
                    {{ field.name }}
                    <span class="text-danger" v-if="Boolean(field.is_required)"
                      >*</span
                    >
                  </label>
                  <div
                    v-for="(option, i) in field?.options"
                    :key="i"
                    class="custom-radio-wrapper"
                  >
                    <input
                      type="radio"
                      disabled
                      class="custom-radio-input"
                      :id="`radio_${field.id}_${i}`"
                      :name="`radio_${field.id}`"
                      :value="option.id"
                      v-model="field.values.id"
                      :icon="field.icon"
                      :required="Boolean(field.is_required)"
                    />
                    <label
                      class="custom-radio-label"
                      :for="`radio_${field.id}_${i}`"
                    >
                      {{ option.name }}
                    </label>
                  </div>
                </div>

                <div v-else-if="field.type === 'select'">
                  <base-select-input
                    :placeholder="field.name"
                    :icon="field.icon"
                    disabled
                    :required="Boolean(field.is_required)"
                    :optionsList="
                      field.options?.map((option) => ({
                        name: option.name,
                        value: option?.name,
                        id: option.id,
                      }))
                    "
                    v-model="field.values"
                  />
                </div>
              </div>
            </div>
          </template>
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.last_updated_date')"
            :value="data.last_updated_date"
            v-if="data.last_updated_date"
            disabled
          />

          <div class="preview-container text-center my-3">
            <h4>{{ $t("PLACEHOLDERS.advertiser_image") }}</h4>
            <img
              v-if="data.advertiser_image"
              col="12"
              :src="data.advertiser_image"
              :alt="$t('PLACEHOLDERS.image')"
            />
          </div>
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.username')"
            :value="data.username"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.advertiser_type')"
            :value="data.advertiser_type.name"
            v-if="data.advertiser_type"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.mobile')"
            :value="data.mobile"
            v-if="data.mobile"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.whatsapp')"
            :value="data.whatsapp"
            v-if="data.whatsapp"
            disabled
          />
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import BaseImageUploadInput from "../../../components/formInputs/BaseImageUploadInput.vue";
import MapComponent from "../../../components/general/MapComponent.vue";
import UploadMedia from "../../../components/formInputs/UploadMedia.vue";

export default {
  name: "CreateAds",
  components: { BaseImageUploadInput, MapComponent, UploadMedia },

  data() {
    return {
      states: [],
      districts: [],
      cities: [],
      isWaitingRequest: false,
      file: null,
      fileType: "",
      currentDate: null,
      selectedDates: [],
      activePicker: "DATE",
      file: null,
      fileType: "",
      districts: [],
      cities: [],
      imgUrls: [],
      additional_fields: [],
      states: [],
      estateTypes: [],
      blocked_days: [],
      blocked_days_data: [], // Store full rent days data with booking status
      data: {
        media: [],
        video: "",
        adNum: null,
        license_number: null,
        created_at: null,
        name: null,
        ad_type: null,
        estate_purpose: null,
        estate_type: null,
        is_featured: null,
        ban_type: null,
        price: null,
        state: null,
        city: null,
        district: null,
        lng: null,
        lat: null,
        rent_type: null,
        description: null,
        area: null,
        estate_front: null,
        street_width: null,
        additional_fields: null,
        last_updated_date: null,
        username: null,
        advertiser_type: null,
        advertiser_image: null,
        mobile: null,
        whatsapp: null,
      },
    };
  },

  computed: {
    currentLang() {
      return this.$i18n.locale;
    },
    adTypes() {
      return [
        {
          id: 1,
          name: this.$t("PLACEHOLDERS.sale"),
          value: "sale",
        },
        {
          id: 2,
          name: this.$t("PLACEHOLDERS.rent"),
          value: "rent",
        },
      ];
    },

    rentTypes() {
      return [
        {
          id: 1,
          name: this.$t("PLACEHOLDERS.daily"),
          value: "daily",
        },
        {
          id: 2,
          name: this.$t("PLACEHOLDERS.monthly"),
          value: "monthly",
        },
        {
          id: 2,
          name: this.$t("PLACEHOLDERS.annual"),
          value: "annual",
        },
      ];
    },
    banTypes() {
      return [
        {
          id: 1,
          name: this.$t("PLACEHOLDERS.construction"),
          value: "construction",
        },
        {
          id: 2,
          name: this.$t("PLACEHOLDERS.commercial"),
          value: "commercial",
        },
        {
          id: 3,
          name: this.$t("PLACEHOLDERS.other"),
          value: "other",
        },
      ];
    },
    estatePurposeTypes() {
      return [
        {
          id: 1,
          name: this.$t("PLACEHOLDERS.residential"),
          value: "residential",
        },
        {
          id: 2,
          name: this.$t("PLACEHOLDERS.commercial"),
          value: "commercial",
        },
      ];
    },
    advertisersTypes() {
      return [
        {
          id: 1,
          name: this.$t("PLACEHOLDERS.owner"),
          value: "owner",
        },
        {
          id: 2,
          name: this.$t("PLACEHOLDERS.broker"),
          value: "broker",
        },
      ];
    },
    facadeTypes() {
      return [
        {
          id: 1,
          name: this.$t("PLACEHOLDERS.northern"),
          value: "northern",
          nvalue: "northern",
        },
        {
          id: 2,
          name: this.$t("PLACEHOLDERS.southern"),
          value: "southern",
          nvalue: "southern",
        },
        {
          id: 3,
          name: this.$t("PLACEHOLDERS.eastern"),
          value: "eastern",
          nvalue: "eastern",
        },
        {
          id: 4,
          name: this.$t("PLACEHOLDERS.western"),
          value: "western",
          nvalue: "western",
        },
        {
          id: 5,
          name: this.$t("PLACEHOLDERS.northeastern"),
          value: "northeastern",
          nvalue: "northeastern",
        },
        {
          id: 6,
          name: this.$t("PLACEHOLDERS.northwestern"),
          value: "northwestern",
          nvalue: "northwestern",
        },
        {
          id: 7,
          name: this.$t("PLACEHOLDERS.southeastern"),
          value: "southeastern",
          nvalue: "southeastern",
        },
        {
          id: 8,
          name: this.$t("PLACEHOLDERS.southwestern"),
          value: "southwestern",
          nvalue: "southwestern",
        },
      ];
    },
  },

  methods: {
    onCopy(event) {
      event.preventDefault();
    },
    onPaste(event) {
      event.preventDefault();
    },
    async getAdsData() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `ads/${this.$route.params.id}`,
        });
        this?.$refs?.ad_images.setFiles(
          res.data.data.Ad.media.map((img) => {
            return { id: img.id, url: img.image };
          })
        );

        this.data.video = {
          path: res.data.data.Ad.video,
          file: null,
        };
        this.data.description = res.data.data.Ad.description;

        this.data.adNum = res.data.data.Ad.id;
        this.data.license_number = res.data.data.Ad.advertiser_license_number;
        this.data.name = res.data.data.Ad.name;
        this.data.created_at = res.data.data.Ad.created_at;
        this.data.ad_type = this.adTypes.find((type) => {
          return type.value === res.data.data.Ad.ad_type;
        });
        this.data.estate_purpose = this.estatePurposeTypes.find((type) => {
          return type.value === res.data.data.Ad.estate_purpose;
        });
        this.data.ban_type = this.banTypes.find((type) => {
          return type.value === res.data.data.Ad.ban_type;
        });
        this.data.estate_type = res.data.data.Ad.estate_type;
        this.data.price = res.data.data.Ad.price;
        this.data.state = res.data.data.Ad.state;
        this.data.city = res.data.data.Ad.city;

        this.data.district = res.data?.data?.Ad?.district;
        await this.getadditionalFields(this.data.estate_type.id);
        this.data.is_featured = res.data.data.Ad.is_featured;

        this.blocked_days_data = res.data?.data?.Ad?.blocked_days || [];
        this.blocked_days = this.blocked_days_data.map((day) => day);
        this.data.lng = res.data?.data?.Ad?.lng;
        this.data.lat = res.data?.data?.Ad?.lat;
        if (res.data?.data?.Ad?.ad_type === "rent") {
          this.data.rent_type = this.rentTypes.find((type) => {
            {
              return type.value === res.data.data.Ad.rent_type;
            }
          });
        }
        this.data.area = res.data.data.Ad?.area;
        this.data.estate_front = this.facadeTypes?.find((type) => {
          return type.value == res.data.data.Ad?.estate_front;
        });
        this.data.street_width = res.data.data.Ad?.street_width;
        this.data.additional_fields = res.data.data.Ad?.additional_fields;
        this.data.last_updated_date = res.data.data.Ad?.last_updated_date;
        this.data.username = res.data.data.Ad?.advertiser?.user.name;
        this.data.advertiser_type = this.advertisersTypes.find((type) => {
          return res.data.data.Ad?.advertiser_type == type.value;
        });
        this.data.advertiser_image = res.data.data.Ad?.advertiser.user.image;
        this.data.mobile = res.data.data.Ad?.advertiser.user.mobile;
        this.data.whatsapp = res.data.data.Ad?.advertiser.user.whatsapp;
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },

    async getEstateTypes(id) {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `estate-types?page=0&limit=0&is_active=1`,
        });
        this.estateTypes = res.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    async getStates(id) {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `states?page=0&limit=0&is_active=1`,
        });
        this.states = res.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    async getDistricts(id) {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `districts?page=0&limit=0&is_active=1&city=${id}`,
        });
        this.districts = res.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    async getCities(id) {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `cities?page=0&limit=0&is_active=1&state=${id}`,
        });
        this.cities = res.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    async getadditionalFields(id) {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `additional-fields?page=0&limit=0&is_active=1&estateType=${id}`,
        });
        this.additional_fields = res.data.data.map((field) => ({
          values: [],
          ...field,
        }));
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
  },

  created() {
    this.getadditionalFields();
    this.getAdsData();

    this.getStates();
    this.getEstateTypes();
  },
};
</script>

<style>
.preview-container img,
.preview-container video {
  max-width: 100%;
  max-height: 200px;
  border: 1px solid #ccc;
  border-radius: 20px;
}
.show .theme--light.v-btn.v-btn--disabled {
  color: var(--theme_text_clr) !important;
}
.bg {
  background-color: green !important;
}
</style>
